import { render, staticRenderFns } from "./SimplePagination.vue?vue&type=template&id=75c7ec64&"
import script from "./SimplePagination.vue?vue&type=script&lang=js&"
export * from "./SimplePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports